import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

export const storyblokProductSearchFiltersGetRedpoints = (): Partial<
  Pick<
    StoryblokProductSearchFiltersType,
    'RPEndDate' | 'RPMultiplier' | 'RPStartDate'
  >
> => {
  const nowDate = Date.now()

  return {
    RPEndDate: { min: nowDate },
    RPMultiplier: { min: 2 },
    RPStartDate: { max: nowDate },
  }
}
